// extracted by mini-css-extract-plugin
export default {"userItemWrapper":"styles_userItemWrapper__drNPW","userItemPhotoWrapper":"styles_userItemPhotoWrapper__YdNbN","userInfoUnit":"styles_userInfoUnit__n-W+X"};